<template>
  <!-- 展商海报生成页面 -->
  <div class="poster-page">
    <div class="poster-page__title">
      <h2>苏州展展商海报生成</h2>
    </div>

    <!-- 海报表单 -->
    <div class="poster-page__form">
      <el-form :model="Form" ref="Form" :rules="rules" status-icon>
        <el-form-item label="公司名" prop="company" class="form-label">
          <el-input v-model="Form.company" placeholder="请输入公司名"></el-input>
        </el-form-item>
        <el-form-item label="展位号" prop="booth" class="form-label">
          <el-input v-model="Form.booth" placeholder="请输入展位号"></el-input>
        </el-form-item>

        <!-- 微信二维码上传 -->
        <el-image v-if="Form.qrc_url !== ''" :src="imgUrl + Form.qrc_url" class="preview-image"></el-image>
        <el-form-item prop="qrc_url" label-width="0px" style="text-align: left">
          <el-upload
            class="avatar-uploader"
            :action="imagesrc"
            :show-file-list="false"
            :on-success="handleQrcUploadSuccess"
            :headers="headers"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary" round>点击上传微信二维码</el-button>
            <span class="upload-tip">*建议比例1:1</span>
          </el-upload>
        </el-form-item>

        <!-- 产品图上传 -->
        <el-image v-if="Form.product_url !== ''" :src="imgUrlp + Form.product_url" class="preview-image"></el-image>
        <el-form-item prop="qrc_url" label-width="0px" style="text-align: left">
          <el-upload
            class="avatar-uploader"
            :action="imagesrcp"
            :show-file-list="false"
            :on-success="handleProductUploadSuccess"
            :headers="headers"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary" round>点击上传产品图</el-button>
            <span class="upload-tip">*建议比例16:9</span>
          </el-upload>
        </el-form-item>

        <el-form-item style="margin-top: 40px">
          <el-button type="primary" @click="onSubmit('Form')">获取海报</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 海报预览弹窗 -->
    <el-dialog :visible.sync="dialogPoster" title="海报" width="80%" center>
      <el-row style="text-align: center">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div>
            <el-image fit="fill" style="max-width: 300px" :src="poster_img"></el-image>
          </div>
          <div class="poster-tip">*微信：可以长按图片保存</div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取消</el-button>
        <el-button type="primary" @click="downloadPoster()">下载</el-button>
      </div>
    </el-dialog>
    <div id="qrcode"></div>
  </div>
</template>

<script>
import api from "../utils/api";

export default {
  name: "poster",
  data() {
    return {
      /** 海报表单数据 */
      Form: {
        company: "",
        phone_number: "",
        qrc_url: '',
        product_url: '',
        Booth: '',
        position: '',
        name: '',
      },
      /** 二维码上传接口地址 */
      imagesrc: this.baseUrl + "/admin/uploadfile/qrc_url/",
      /** 产品图上传接口地址 */
      imagesrcp: this.baseUrl + "/admin/uploadfile/product_url/",
      /** 产品图 OSS 前缀 */
      imgUrlp: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product_url/',
      /** 二维码 OSS 前缀 */
      imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/qrc_url/',
      /** 上传请求头（携带 Token） */
      headers: { "Authorization": "JWT " + localStorage.getItem('adminToken') },
      /** 生成的海报图片地址 */
      poster_img: '',
      /** 表单校验规则 */
      rules: {
        company: [{ required: true, message: "请输入公司名", trigger: "blur" }],
        booth: [{ required: true, message: "请输入展位号", trigger: "blur" }],
      },
      /** 海报预览弹窗是否显示 */
      dialogPoster: false
    }
  },

  mounted() {
    this.updateViewport();
  },

  methods: {
    /**
     * 提交表单生成海报
     * 校验表单后调用接口，返回海报图片地址并弹窗预览
     * @param {string} formname - 表单 ref 名称
     */
    onSubmit(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let url = this.baseUrl + "/admin/getposter/";
          let qrc_url = this.Form.qrc_url ? this.imgUrl + this.Form.qrc_url : '';
          let product_url = this.Form.product_url ? this.imgUrlp + this.Form.product_url : '';

          api.postData(url, {
            qrc_url: qrc_url,
            company: this.Form.company,
            booth: this.Form.booth,
            product_url: product_url
          }).then((res) => {
            this.poster_img = 'https://cloudexhibition.chinafastenerinfo.com/' + res.poster_url;
            this.$message({ message: "提交成功", type: "success" });
            this.dialogPoster = true;
          });
        }
      });
    },

    /**
     * 二维码图片上传成功回调
     * @param {object} res - 上传响应数据
     * @param {object} file - 文件对象
     */
    handleQrcUploadSuccess(res, file) {
      this.Form.qrc_url = res.filename;
    },

    /**
     * 产品图上传成功回调
     * @param {object} res - 上传响应数据
     * @param {object} file - 文件对象
     */
    handleProductUploadSuccess(res, file) {
      this.Form.product_url = res.filename;
    },

    /** 图片上传前的校验（暂不做限制） */
    beforeAvatarUpload(file) {},

    /** 关闭海报预览弹窗 */
    cancel() {
      this.dialogPoster = false;
    },

    /**
     * 下载海报图片
     * 通过 Canvas 将图片转为 base64 并触发下载
     */
    downloadPoster() {
      if (this.poster_img) {
        this.downloadByAxios(this.poster_img, '海报');
      } else {
        this.$message({ message: "海报为空", type: "warning" });
      }
    },

    /**
     * 通过 Canvas 下载图片（解决跨域问题）
     * @param {string} url - 图片地址
     * @param {string} name - 下载文件名
     */
    downloadByAxios(url, name) {
      document.getElementById('qrcode').innerHTML = '';
      const image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        const dataUrl = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        const event = new MouseEvent('click');
        a.download = name || 'photo';
        a.href = dataUrl;
        a.dispatchEvent(event);
      };
      image.src = url;
    },

    /** 设置 viewport meta 标签（适配移动端） */
    updateViewport() {
      const meta = document.querySelector('meta[name="viewport"]');
      if (meta) {
        meta.setAttribute('content', 'width=device-width, initial-scale=1.0');
      } else {
        const newMeta = document.createElement('meta');
        newMeta.setAttribute('name', 'viewport');
        newMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=0');
        document.head.appendChild(newMeta);
      }
    },
  }
}
</script>

<style scoped>
/* 海报页面容器 */
.poster-page {
  max-width: 800px;
  margin: 20px auto;
  background-color: var(--card-bg, #ffffff);
  border-radius: var(--radius-lg, 8px);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.05));
}

.poster-page__title {
  padding: var(--spacing-lg, 24px) var(--spacing-lg, 24px) 0;
}

.poster-page__title h2 {
  margin: 0;
  color: var(--text-primary, #1e293b);
}

.poster-page__form {
  padding: 0 var(--spacing-lg, 24px) var(--spacing-lg, 24px);
}

.form-label {
  margin-top: 20px;
  font-weight: bold;
  font-size: 18px;
}

.preview-image {
  width: 200px;
  height: 200px;
}

.upload-tip {
  font-size: 12px;
  color: var(--text-muted, #94a3b8);
  margin-left: 8px;
}

.poster-tip {
  font-size: 12px;
  text-align: left;
  padding-top: 10px;
  color: var(--text-muted, #94a3b8);
}

@media screen and (max-width: 400px) {
  .poster-page {
    width: 100%;
    margin: 0;
    border-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/poster.vue